<div class="theme-preview-wrapper" >
  <div class="ph-photo-theme-preview">
    <div class="ph-photo-theme-preview__container">
      <div class="ph-photo-theme-preview__image-overlay"></div>
      <div class="ph-photo-theme-preview__image-remove" (click)="emitClose($event)">
        <img src="assets/img/icons/remove-photo.svg" [alt]="'PROJECT.remove_photo' | translate" />
      </div>
      <div class="ph-photo-theme-preview__image-change">
        {{ 'PROJECT.change_image' | translate }}
      </div>
      <img [src]="currentUpload" />
    </div>
  </div>
</div>
